export default {
  state: {

    inventoryItems: [
      {
        type: 'decoderPowerBrick'
      }
    ]

  }
}
